import {Editor, Extension} from '@tiptap/core'

interface TipTapCoreImport {
    Editor: typeof Editor
}

export default class TipTapCoreLoader {

    /**
     * 0 - not loaded
     * 1 - loading
     * 2 - loaded
     * @private
     */
    private static status = 0;

    private static promise: Promise<TipTapCoreImport>;

    private static instance: TipTapCoreImport;

    public static load(): Promise<TipTapCoreImport> {
        if (TipTapCoreLoader.status == 0) {
            TipTapCoreLoader.status = 1;

            TipTapCoreLoader.promise = Promise.all([
                import(/* webpackChunkName: "tiptap-core" */ '@tiptap/core')
            ]).then(v => {
                console.log("TIP TAP LOADER", v);

                let core = v[0];

                let exp = {
                    Editor: core.Editor,
                } as unknown as TipTapCoreImport;

                TipTapCoreLoader.instance = exp;
                TipTapCoreLoader.status = 2;

                return exp;

            });


            return TipTapCoreLoader.promise;
        } else if (TipTapCoreLoader.status == 1) {
            return TipTapCoreLoader.promise;
        } else {
            return Promise.resolve(TipTapCoreLoader.instance);
        }
    }

}